/**
 * The picture around a diagram: its title above and the margin that centres a narrow
 * diagram on the canvas. Diagrams lay themselves out with a 16-unit margin of their own,
 * so this only adds what a title needs.
 */

import { layoutTitle, type TitleBlock } from "@/lib/tool-kit/charts/layout";

export interface TitledFrame {
  width: number;
  height: number;
  /** Where the diagram's own origin sits on the canvas. */
  dx: number;
  dy: number;
  title: TitleBlock | null;
}

const TITLE_TOP = 8;

export function titledFrame(
  contentWidth: number,
  contentHeight: number,
  title: string,
  minWidth = 360
): TitledFrame {
  const width = Math.max(contentWidth, minWidth);
  const block = layoutTitle(title, width, TITLE_TOP);
  const dy = block ? block.height + 4 : 0;
  return {
    width,
    height: contentHeight + dy,
    dx: (width - contentWidth) / 2,
    dy,
    title: block,
  };
}
